import styled from "styled-components";

import { WizardButtonsWrapper } from "app/components/campaigns/campaigns-wizard/CampaignsStyledComponents";

export const StyledCrmEnrichmentWizardButtonsWrapper = styled(WizardButtonsWrapper)`
    max-width: 900px;
    margin: 0 auto;
`;
